class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px -100px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        const container = document.getElementById("recommendations");
        const parent = document.querySelector(".r-section");
        if (!container) return;
        initProductCards(container);
        initSlider(container);

        // Set max-height to accommodate all content including arrows
        if (parent) {
          // Use a large enough value to show all content initially
          parent.style.maxHeight = "5000px";

          // After slider initializes and layout stabilizes, calculate proper height
          setTimeout(() => {
            // Measure the actual content height including all children
            const containerHeight =
              container.offsetHeight || container.scrollHeight;
            // Add extra buffer for arrows and padding
            const totalHeight = containerHeight + 300;
            parent.style.maxHeight = `${totalHeight}px`;
          }, 300); // Wait for slider initialization to complete
        }
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
